import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Visitors Onboarding Mirage Scenario
 *
 * @param {object} server Mirage Server
 * @param {object} options scenario options
 */
export default function (server, options = { complete: false }) {
  const {
    subscription,
    locations: [mainLocation],
    flows: [flow],
  } = visitorsClassicScenario(server);

  subscription.update({
    trialEndDate: null,
    last4: '1234',
    expirymonth: 10,
    expiryyear: 2019,
    brand: 'Visa',
    plan: 'enterprise',
    period: 'yearly',
    couponPercentOff: 10,
    features: [
      'billing',
      'sign_in_visitors',
      'custom_notifications',
      'group_sign_in',
      'nda_enabled',
      'visitor_photos',
      'visitor_badge_printing',
      'sms_notification',
      'slideshows',
      'custom_badge',
      'presign_nda',
      'multiple_visitor_types',
      'sign_in_from_invite',
      'slack',
      'analytics',
      'assistants',
      'blacklist',
      'locations_grouping',
      'global_analytics',
    ],
  });

  mainLocation.update({
    printerIds: [],
  });

  const STEPS = [
    {
      subtitle: 'Download the Visitors app and pair a new iPad.',
      title: 'Pair a new iPad',
      page: 'devices',
      skippable: true,
      stepNumber: 1,
    },
    {
      subtitle: 'Give your sign in a whirl to see what it’s like for visitors.',
      title: 'Sign yourself in on the iPad',
      page: 'entries',
      skippable: true,
      stepNumber: 2,
    },
    {
      subtitle: 'Add your employee directory to send notifications when visitors arrive.',
      title: 'Notify employees when their visitors arrive',
      page: 'visitorsEmployeesImport',
      skippable: true,
      stepNumber: 3,
    },
    {
      subtitle: 'Add questions, take photos, and more.',
      title: 'Customize your sign-in flow',
      page: 'fields',
      skippable: true,
      stepNumber: 4,
    },
    {
      subtitle: 'Connect a printer to start printing badges for guests.',
      title: 'Print visitor badges',
      page: 'newPrinter',
      skippable: true,
      stepNumber: 5,
    },
    {
      subtitle: 'Pre-register office guests for a smoother arrival.',
      title: 'Schedule an upcoming visit',
      page: 'newInvite',
      skippable: true,
      stepNumber: 6,
    },
  ];

  if (options.complete) {
    mainLocation.update({ visitorsOnboardingComplete: true, flowIds: [flow.id] });
  } else {
    mainLocation.update({ visitorsOnboardingComplete: false, flowIds: [flow.id] });
    server
      .createList('locations-setup-guide-step', STEPS.length, {
        location: mainLocation,
      })
      .forEach((step, idx) => step.setupGuideStep.update(STEPS[idx]));
  }

  return {
    location: mainLocation,
  };
}
